import { BuildHistoryPanel } from '@/components/shared/build-history-panel';

type BuildHistoryPanelProps = {
  tenantSlug: string;
};

export function BuildHistoryPanelTab({ tenantSlug }: BuildHistoryPanelProps) {
  return (
    <BuildHistoryPanel
      tenantSlug={tenantSlug}
      title="Build History"
      description="View the complete build history for this tenant"
    />
  );
}
